// Centralized static content for Admiral Roofing & Home Improvement

// ── Client uploaded photos (real roofing projects) ──────────────────────────
export const CLIENT_PHOTOS = {
  aerialPeaked:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_admiral-roofing/artifacts/kzx27qe1_53BCAE3F-6F60-44E3-9099-76059F73B28F.jpeg",
  tearoffBefore:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_admiral-roofing/artifacts/8k5z7wvq_83DEDA7D-8592-4DD5-8461-7FA19A4A028F.jpeg",
  newRoofAfter:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_admiral-roofing/artifacts/3syjhzn2_53BCAE3F-6F60-44E3-9099-76059F73B28F.jpeg",
  partialInstall:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_admiral-roofing/artifacts/54c65mdz_9E197DB9-DF0F-498D-93AB-D38E7FE026EA.jpeg",
  closeUpShingles:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_admiral-roofing/artifacts/ynmbr693_37D02C02-57E4-47E2-87EB-5BFD84D54570.webp",
  ridgeChimney:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_admiral-roofing/artifacts/p0214qia_8898C71E-EFE9-4A57-BB39-834E17F62639.webp",
};

export const COMPANY = {
  name: "Admiral Roofing & Home Improvement",
  shortName: "Admiral Roofing",
  tagline: "Braintree's Premier Roofing Specialists",
  city: "Braintree, Massachusetts",
  phone: "(781) 706-2132",
  phoneTel: "+17817062132",
  email: "info@admiralroofingma.com",
  address: "36 Central Ave, Braintree, MA",
  hours: [
    { day: "Mon – Fri", time: "7:00 AM — 6:00 PM" },
    { day: "Saturday", time: "8:00 AM — 2:00 PM" },
    { day: "Sunday", time: "Emergency Calls Only" },
  ],
  yearsInBusiness: 30,
  roofsCompleted: "1,000+",
  founded: 1994,
};

// ── PRIMARY: Roofing & related services (in exact display order) ────────────
export const PRIMARY_SERVICES = [
  {
    id: "roof-replacement",
    title: "Roof Replacement",
    blurb:
      "Full tear-off and installation of asphalt, architectural shingle, slate and metal roofing — built to shed New England weather for decades.",
    points: [
      "GAF & CertainTeed Certified",
      "Lifetime Material Warranties",
      "Full Tear-Off & Clean Site",
    ],
    icon: "Home",
  },
  {
    id: "roof-repair",
    title: "Roof Repair",
    blurb:
      "Targeted repair of missing shingles, failed flashing, ventilation issues, valleys and aging seams — with a workmanship guarantee.",
    points: [
      "Leak & Flashing Fixes",
      "Missing Shingles",
      "Same-Week Scheduling",
    ],
    icon: "Wrench",
  },
  {
    id: "roof-inspections-drone",
    title: "Roof Inspections by Drone",
    blurb:
      "Aerial drone inspections that catch problems the ground can't. Full photo & video report delivered same day.",
    points: [
      "See Actual Footage",
      "Real Estate Inspections",
      "Storm Damage Checks",
    ],
    icon: "Camera",
  },
  {
    id: "storm-leak",
    title: "Storm & Leak Damage",
    blurb:
      "Emergency tarping, leak-source tracing and full insurance-claim documentation after wind, hail or ice damage.",
    points: [
      "24-Hr Emergency Response",
      "Insurance-Claim Liaison",
      "Interior Leak Tracing",
    ],
    icon: "CloudRain",
  },
  {
    id: "gutters",
    title: "Gutter Installations & Guards",
    blurb:
      "Seamless aluminum gutters and leaf-guard systems sized for New England snowmelt and heavy rain.",
    points: [
      "Seamless Aluminum Gutters",
      "Leaf & Debris Guards",
      "Heavy Rain Protection",
    ],
    icon: "Workflow",
  },
  {
    id: "skylights-ventilation",
    title: "Skylights & Roof Ventilation",
    blurb:
      "Modern skylight installation plus attic and ridge ventilation to keep your roof cool and your attic dry.",
    points: [
      "Modern Skylight Install",
      "Attic & Ridge Vents",
      "Leak-Proof Guarantee",
    ],
    icon: "Sun",
  },
  {
    id: "chimney-repairs",
    title: "Chimney Repairs",
    blurb:
      "Brick, mortar, flashing and structural chimney work sealed water-tight against every season.",
    points: [
      "Masonry & Brickwork",
      "Counter Flashing Fixes",
      "Structural Sealing",
    ],
    icon: "Flame",
  },
  {
    id: "insurance-claims",
    title: "Insurance Claims",
    blurb:
      "We handle the paperwork, the photos, and the phone calls — so your storm claim actually gets approved.",
    points: [
      "Work Directly With Adjusters",
      "Full Storm Documentation",
      "Deductible Assistance",
    ],
    icon: "FileCheck",
  },
];

// ── SECONDARY: Non-roofing offerings (kept at the end) ──────────────────────
export const SECONDARY_SERVICES = [
  {
    id: "kitchen-bath",
    title: "Kitchen & Bath Remodeling",
    blurb: "Cabinetry, tile, fixtures and full-layout redesigns — built water-tight and built to last.",
    icon: "Utensils",
  },
  {
    id: "siding",
    title: "Siding Services",
    blurb: "Vinyl, fiber-cement and cedar siding that restores curb appeal to your entire home.",
    icon: "LayoutGrid",
  },
];

// Legacy combined list (still used by contact form dropdown & footer)
export const SERVICES = [...PRIMARY_SERVICES, ...SECONDARY_SERVICES];

// ── Roofing systems / materials expertise ───────────────────────────────────
export const ROOFING_SYSTEMS = [
  {
    id: "asphalt",
    name: "Asphalt Shingle",
    tagline: "The New England workhorse",
    features: [
      "20–50 yr manufacturer warranties",
      "Architectural & 3-tab profiles",
      "Best value for typical residential roofs",
    ],
  },
  {
    id: "slate",
    name: "Slate",
    tagline: "Century-lasting stone",
    features: [
      "75–150 yr lifespan",
      "Fireproof & hail-resistant",
      "Ideal for historic New England homes",
    ],
  },
  {
    id: "metal",
    name: "Metal",
    tagline: "Standing-seam durability",
    features: [
      "40–70 yr lifespan",
      "Sheds snow & ice loads",
      "Energy-reflective options available",
    ],
  },
  {
    id: "copper",
    name: "Copper",
    tagline: "Heirloom-grade craftsmanship",
    features: [
      "100+ yr lifespan with natural patina",
      "Custom bay windows, turrets & accents",
      "Solder-seam installation by hand",
    ],
  },
  {
    id: "cedar-shake",
    name: "Cedar Shake",
    tagline: "Classic New England character",
    features: [
      "Naturally insulating & breathable",
      "Hand-split & tapersawn options",
      "30–40 yr lifespan with proper care",
    ],
  },
  {
    id: "epdm-flat",
    name: "EPDM / Flat Roofing",
    tagline: "Modern & commercial-grade",
    features: [
      "Seamless rubber-membrane installation",
      "Ideal for porches, garages, additions",
      "25–30 yr warranty & UV-stable",
    ],
  },
];

export const REVIEWS = [
  {
    name: "Marissa Cohen",
    quote:
      "We needed some updating of our bathroom. We got an estimate that was crazy high. Then we called Jeff at Admiral Roofing & Home Improvement. He came and talked things over with us and gave us a very reasonable estimate. The most important thing was that while he was there, he fixed the leaking shower head so we wouldn't continue to waste water! They completed the job on time, and we are really happy with the work. Highly recommend Jeff and his crew!",
    rating: 5,
    project: "Bathroom Remodel",
  },
  {
    name: "Ken Prince",
    quote:
      "Jeffrey is amazing. I've hired him several times for issues involving my roof. He is always quick to respond and goes above and beyond to meet my needs. It also helps that he's personable and gives 100% to every job. If you have roofing issues you won't be disappointed with his work.",
    rating: 5,
    project: "Roof Repair",
  },
  {
    name: "Lloyd Le",
    quote:
      "After 19 years in the house, we needed a roof replacement and chimney rework. We had 5 competitive quotes and we are so glad we picked Admiral Roofing. Jeffrey is very attentive and responsive (he answered my text at 10PM on Sunday night!).",
    rating: 5,
    project: "Roof Replacement & Chimney",
  },
  {
    name: "Nathaniel Lyon",
    quote:
      "I've worked with Jeffrey a few times now, and I can say that he is one of the best contractors I've ever worked with. He is incredibly personable and makes all the time you need to either go over your project or just shoot the breeze.",
    rating: 5,
    project: "General Contracting",
  },
  {
    name: "Tony Humphries",
    quote:
      "Originally I found, and hired, Jeffrey to repair broken PVC fence on a newly purchased house. He did a great job and I hired him multiple times over the years for misc landscaping projects. Jeffrey and his team also built me a beautiful deck.",
    rating: 5,
    project: "Fencing & Deck",
  },
  {
    name: "Jacquelyn Connerty",
    quote:
      "My home is 90 years old and has been added on to several times. It has peaked and flat roofs and a covered porch. We had leaks! I got three estimates for a roof replacement and Admiral Roofing and Home Improvement offered the best value and craftsmanship.",
    rating: 5,
    project: "Roof Replacement",
  },
  {
    name: "Casey Hiltz",
    quote:
      "The owner Jeff and his crew were awesome. Job was done quickly and efficiently. The clean up was unbelievable! Jeff was super reliable throughout the entire process, would 100% use Admiral Roofing and Home Improvement again.",
    rating: 5,
    project: "Roofing",
  },
  {
    name: "Erica Lit",
    quote:
      "It is so hard to find people you can trust with your home. If you're looking for skilled craftsmanship, someone trustworthy, talented and patient look no further! Admiral Roofing and Home Improvement was an absolute pleasure to work with.",
    rating: 5,
    project: "Home Improvement",
  },
  {
    name: "Laurel Cheever",
    quote:
      "Our goal was to find an honest, trustworthy roofer that would give us quality work and not charge an arm and leg. We met with many companies and got several bids. We chose Admiral Roofing and Home Improvement after looking at some of their work.",
    rating: 5,
    project: "Roofing",
  },
  {
    name: "Cassandra Cheever",
    quote:
      "My husband and I needed a new roof on our home and we worked with the owner Jeff. He was very knowledgeable and was able to answer all of our questions all while making us feel at ease during a large construction project. The quality of the work was incredible and we would absolutely work with him again!",
    rating: 5,
    project: "Roof Replacement",
  },
  {
    name: "Maureen Lord",
    quote:
      "In the last 10+ years, Admiral Roofing and Home Improvement has helped make our home better and safer through various projects on the inside and outside of the house. He knows the house and is skilled and knowledgeable in so many areas.",
    rating: 5,
    project: "Home Improvement",
  },
  {
    name: "Jean Fitzmaurice",
    location: "Holbrook, MA",
    quote:
      "Jeffrey and crew did a fantastic job with my new roof in the Holbrook, MA area. Note this job included strip and replace (real old roof). Through the entire process Jeff was professional, personable and provided quality product at a reasonable cost.",
    rating: 5,
    project: "Roof Replacement",
  },
  {
    name: "Cindy",
    quote:
      "Jeffrey helped me out when I was in a bind and really needed someone right away. He was kind, considerate, trustworthy and did a great job. I'd absolutely recommend him and his company Admiral Roofing.",
    rating: 5,
    project: "Roof Repair",
  },
  {
    name: "Himothy Turner",
    quote:
      "I recommend Admiral Roofing to any and everyone looking to get quality work done in a timely manner. The employees were very kind and professional. The service they provided by far exceeded our expectations! They followed through with everything.",
    rating: 5,
    project: "Roofing",
  },
  {
    name: "Christopher Anderson",
    quote:
      "My wife and I had some issues with our old roof and decided it was time to get a new one. After a lot of research and recommendations, we had Jeff and his crew put a new one on for us. We couldn't be happier with the finished product. The price was on point and they did it in no time. Would highly recommend them!!!",
    rating: 5,
    project: "Roof Replacement",
  },
  {
    name: "Andrew Lewis",
    location: "Bridgewater, MA",
    quote:
      "Great job on my roof in Bridgewater. Jeffrey was on time, on price, and the quality was great. They paid attention to detail and made the yard spotless when they left.",
    rating: 5,
    project: "Roofing",
  },
  {
    name: "Joe Jeffcoat",
    quote:
      "Jeff was very professional and answered all my questions. The cost was what he quoted and he was done on time. I wish all companies were run with honor like his.",
    rating: 5,
    project: "Roofing",
  },
  {
    name: "Chad Spaulding",
    quote:
      "I have worked with Jeff for years and he is a stand up go getter! You won't be disappointed you called him!!",
    rating: 5,
    project: "Home Improvement",
  },
  {
    name: "Mohammad Jamil",
    quote:
      "They were very professional and showed up on time. All work was completed as described. Thank you!",
    rating: 5,
    project: "Roofing",
  },
  {
    name: "Melissa Alden",
    quote:
      "Great work! Really nice and professional employees. Highly recommend.",
    rating: 5,
    project: "Home Improvement",
  },
];

// ── Before & After project pairs ────────────────────────────────────────────
export const BEFORE_AFTER = [
  {
    id: "full-strip-replace",
    title: "Full Strip & Architectural Shingle Replacement",
    location: "South Shore, MA",
    summary:
      "Complete tear-off of the failing original roof followed by installation of GAF architectural shingles in charcoal — cleaned and sealed in three days.",
    before: {
      url: "https://customer-assets-eiarnc6j.emergentagent.net/job_admiral-roofing/artifacts/8k5z7wvq_83DEDA7D-8592-4DD5-8461-7FA19A4A028F.jpeg",
      caption: "Before — tear-off in progress",
    },
    after: {
      url: "https://customer-assets-eiarnc6j.emergentagent.net/job_admiral-roofing/artifacts/3syjhzn2_53BCAE3F-6F60-44E3-9099-76059F73B28F.jpeg",
      caption: "After — new architectural shingle",
    },
  },
];

// ── Gallery items (roofing-focused with client photos + stock supplements) ──
export const GALLERY_ITEMS = [
  {
    url: CLIENT_PHOTOS.aerialPeaked,
    title: "Complete Roof Replacement",
    location: "Braintree, MA",
    category: "Roofing",
  },
  {
    url: CLIENT_PHOTOS.partialInstall,
    title: "Mid-Install Aerial View",
    location: "South Shore, MA",
    category: "Roofing",
  },
  {
    url: CLIENT_PHOTOS.tearoffBefore,
    title: "Full Tear-Off in Progress",
    location: "South Shore, MA",
    category: "Roofing",
  },
  {
    url: CLIENT_PHOTOS.closeUpShingles,
    title: "GAF Architectural Shingle Detail",
    location: "Braintree, MA",
    category: "Roofing",
  },
  {
    url: CLIENT_PHOTOS.ridgeChimney,
    title: "Ridge & Chimney Flashing",
    location: "Braintree, MA",
    category: "Roofing",
  },
  {
    url: "https://images.unsplash.com/photo-1710139323182-69622cad5c3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Asphalt Shingle Replacement",
    location: "Weymouth, MA",
    category: "Roofing",
  },
  {
    url: "https://images.unsplash.com/photo-1557671009-600c3a1973ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Red Brick Roof Repair",
    location: "Quincy, MA",
    category: "Roofing",
  },
  {
    url: "https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Pitched Roof Installation",
    location: "Milton, MA",
    category: "Roofing",
  },
  {
    url: "https://images.unsplash.com/photo-1646324554833-f0b6a479fa5d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Chimney Flashing Restoration",
    location: "Braintree, MA",
    category: "Roofing",
  },
  {
    url: "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Cedar Siding Restoration",
    location: "Hingham, MA",
    category: "Siding",
  },
  {
    url: "https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Modern Fiber-Cement Siding",
    location: "Randolph, MA",
    category: "Siding",
  },
  {
    url: "https://images.unsplash.com/photo-1779905691544-1acb9da678c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Walk-In Shower Bath Remodel",
    location: "Weymouth, MA",
    category: "Bathroom",
  },
  {
    url: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Custom Kitchen Renovation",
    location: "Braintree, MA",
    category: "Kitchen",
  },
];

export const STATS = [
  { value: "30+", label: "Years in Business" },
  { value: "1,000+", label: "Roofs Completed" },
  { value: "100%", label: "Local South Shore Crews" },
  { value: "5★", label: "Average Customer Rating" },
];
